<template>
    <v-dialog
        v-model="dialog"
        max-width="700px"
        min-height="427px"
        :opacity="0.8"
        class="settings-dialog"
        @after-leave="$emit('close')"
    >
        <v-card class="settings-dialog-card">
            <settings-layout
                component-name="UserSettings"
                :component-title="$t('user_settings.title')"
                :navigation-items="navigationItems"
                :show-close-button="true"
                @close="dialog = false"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import SettingsLayout from '../../../components/layouts/SettingsLayout.vue';
import ChangeEmail from './ChangeEmail.vue';
import ChangeUsername from './ChangeUsername.vue';
import ChangePassword from './ChangePassword.vue';
import DeleteUser from './DeleteUser.vue';
import ChangeLanguage from './ChangeLanguage.vue';
import { useUserStore } from '@/stores/user.js';

export default {
    name: 'UserSettings',
    components: {
        SettingsLayout,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close'],
    data: () => ({
        userStore: useUserStore(),
    }),
    computed: {
        navigationItems() {
            return [
                {
                    title: this.$t('user_settings.change_email.title'),
                    icon: 'mdi-email',
                    component: ChangeEmail,
                },
                {
                    title: this.$t('user_settings.change_name.title'),
                    icon: 'mdi-account',
                    component: ChangeUsername,
                },
                {
                    title: this.$t('user_settings.change_password.title'),
                    icon: 'mdi-lock',
                    component: ChangePassword,
                },
                {
                    title: this.$t('user_settings.change_language.title'),
                    icon: 'mdi-translate-variant',
                    component: ChangeLanguage,
                },
                {
                    title: this.$t('user_settings.delete_account.title'),
                    icon: 'mdi-delete',
                    component: DeleteUser,
                },
            ];
        },
        dialog: {
            get() {
                return this.visible;
            },
            set() {
                this.$emit('close');
            },
        },
    },
    methods: {
        switchLang(lang) {
            this.userStore.set_locale(lang);
        },
    },
};
</script>

<style lang="scss">
.settings-dialog {
    height: 100%;
    min-height: 427px;
    max-height: 550px;

    &-card {
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 8px !important;
    }
}
</style>
